export default __webpack_public_path__ + "static/media/NTORQ 125_1.6db36af0.webp";